
import React from 'react';
import './loader.css';

function Loader({ size = 'medium', text = 'Loading...', center = false }) {
  const loaderClass = `loader ${size} ${center ? 'center' : ''}`;
  
  return (
    <div className={loaderClass}>
      <div className="spinner">
        <div className="spinner-inner"></div>
      </div>
      {text && <div className="loader-text">{text}</div>}
    </div>
  );
}

export default Loader;
